import axios from 'axios';
import { TOKEN } from '@Consts/strings';
import { versao } from '@Config/versions';
import { getCurrentCompanyUnit } from '@Config/unidades';
import { envs, localStorageEnvKey } from '@Config/environments';
import { clearAxiosResponseData } from 'luiz-fns';
import store from '../store';
import { url_api } from './url-api';

const type_environments = {
	production: 'production',
	development: 'development',
	staging: 'staging',
	lab: 'lab',
	local: 'local'
};

const env = localStorage.getItem(localStorageEnvKey);
const companyUnityHeader = 'X-Company-Unit-Id';

const chooseAxios = environment => {
	let url;
	switch (environment || envs) {
		case type_environments.production || (env && env === envs.Prod):
			url = url_api.Prod; break;
		case type_environments.development || (env && env === envs.Dev):
			url = url_api.Dev; break;
		case type_environments.staging || (env && env === envs.Staging):
			url = url_api.Staging; break;
		case type_environments.lab || (env && env === envs.Lab):
			url = url_api.Lab; break;
		case type_environments.local || (env && env === envs.Local):
		default:
			url = url_api.Local; break;
	}

	const http = axios.create({
		baseURL: url
	});

	http.interceptors.request.use(
		config => {
			const user_token = localStorage.getItem(TOKEN);
			config.headers.Authorization = `Bearer ${user_token}`;
			config.headers.version = versao;
			config.headers[companyUnityHeader] = getCurrentCompanyUnit()?.id || '';
			config.headers.colaboradorView = store.getters.visao_colaborador ? 'AF%u4nE9t2MB' : 'gRH!iqE%4mKA';
			return config;
		},
		error => Promise.reject(error)
	);

	http.interceptors.response.use(
		clearAxiosResponseData
	);

	return http;
};
export default chooseAxios;
